import { TitleCasePipe } from '@angular/common';
import {
    HTTP_INTERCEPTORS,
    provideHttpClient,
    withFetch,
    withInterceptorsFromDi,
} from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LetDirective, PushPipe } from '@ngrx/component';
import { ERROR_CONFIG } from 'shared/base/generics/globals/errors/error-dialog.service';
import { ScriptInjectionService } from 'sharedGlobals/gtm-data-layer/script-injection.service';
import { SharedModule } from 'shared/shared.module';
import { BaseStoreModule } from 'stores/base-store.module';
import { ModalService } from 'shared/base/generics/globals/modals/modal.service';
import { ApiInterceptor } from '../interceptors/api.interceptor';

@NgModule({
    declarations: [],
    exports: [],
    imports: [
        BaseStoreModule,
        SharedModule,
        LetDirective,
        PushPipe,
        FormsModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
    ],
    providers: [
        provideHttpClient(withFetch()),
        ScriptInjectionService,
        ModalService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ApiInterceptor,
            multi: true,
        },
        TitleCasePipe,
        provideHttpClient(withInterceptorsFromDi()),
    ],
})
export class BaseModule {
    constructor() {}

    public static forRoot(config?: any): ModuleWithProviders<BaseModule> {
        const moduleProviders = SharedModule.forRoot(config).providers;
        moduleProviders.push([
            {
                provide: ERROR_CONFIG,
                useValue: config?.errorModal,
            },
            {
                provide: 'env',
                useValue: config?.environment,
            },
            {
                provide: 'gtmId',
                useValue: config?.gtmId,
            },
            {
                provide: 'fbId',
                useValue: config?.fbId,
            },
            {
                provide: 'urlHeaderWhiteList',
                useValue: config?.urlHeaderWhiteList,
            },
        ]);
        return {
            ngModule: BaseModule,
            providers: moduleProviders,
        };
    }
}
